<template>
  <!-- Cool Stuff Animated Text Overlay -->
  <CoolStuff :backgroundColor="effectiveBackgroundColor" />
  <div class="bg-white/80 text-dark-teal-600 font-['Inter'] text-base font-normal leading-relaxed tracking-tight fixed left-0 right-0 z-50 transition-[top] duration-200" :style="{ top: 'var(--demo-alert-height, 0px)' }">
    <div
      class="justify-between bg-white/80 border-b border-gray-200 top-0 left-0 right-0 z-50 pr-4 pl-4 h-12 lg:h-16 sticky flex lg:pl-8 lg:pr-0 sticky top-0 left-0"
      :key="localeRenderKey"
    >
      <!-- Left: Logo + Theme Toggle -->
      <div class="flex items-center gap-4">
        <NuxtLink class="flex items-center text-dark-teal-600 hover:text-dark-teal-900 transition-all duration-200" :to="localePath('index')" :aria-label="t('common.brand')">
          <h1 class="text-4xl font-serif antialiased">{{ t('common.brand') }}</h1>
          <!-- <img loading="lazy" alt="Ommi logo" class="h-12" src="/images/logo-ommi.svg"> -->
        </NuxtLink>
        <LanguageSwitcher variant="desktop" />
        <!-- Theme Toggle Button (Sample Product Page Only) -->
        <button 
          v-if="isSampleProductPage"
          @click="toggleGlobalTheme"
          class="flex items-center justify-center w-6 h-6 rounded-full border border-gray-200 bg-white hover:bg-black hover:text-white transition-all duration-200"
          :title="themeToggleTitle"
        >
          <svg v-if="globalTheme === 'day'" class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/>
          </svg>
          <svg v-else class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 8 0z"/>
          </svg>
        </button>
        <!-- <a target="_blank" rel="noopener noreferrer" class="ml-3 flex items-center gap-1.5 rounded-full p-1.5 border border-gray-200 no-underline hover:bg-light-pink-100 text-dark-teal-600 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-[2px_2px_0_0_rgba(0,0,0,1)] transition-all duration-100" aria-label="Visit Gumroad on GitHub" data-github-stars="true" href="https://github.com/antiwork/gumroad">
          <svg width="20" height="20" viewBox="0 0 98 96" xmlns="http://www.w3.org/2000/svg" class="fill-current">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z" fill="currentColor"></path>
          </svg>
          <div data-github-stars-count="" class="flex items-center gap-1.5">
            <span class="text-base leading-none font-medium" data-github-stars-count-value="">90K</span>
            <img width="18" height="18" src="https://assets.gumroad.com/assets/icons/solid-star-ae9395f76968c94940ad3171be53dc6dd6d8d5f2e528d991a22222e22ded0e98.svg">
          </div>
          <div data-github-stars-arrow="" class="flex items-center gap-1.5 hidden">
            <span class="text-base leading-none font-medium">GitHub</span>
            <img width="14" height="14" src="https://assets.gumroad.com/assets/icons/arrow-diagonal-up-right-a61db6579af1e1d6579c674d741e41fdf0271db9f2a1ad1450e80b7fb0ae2b7f.svg">
          </div>
        </a> -->
      </div>
      <!-- Center + Right: Desktop Nav & Auth -->
      <div class="override hidden lg:flex lg:items-center">
        <div class="flex flex-col justify-center items-center lg:flex-row lg:mr-2">
          <NuxtLink 
            class="lowercase font-medium h-12 lg:h-16 font-serif cursor-pointer flex w-full text-2xl items-center justify-center border border-transparent no-underline transition-all duration-200 hover:bg-light-pink-200 hover:text-dark-teal-600 lg:w-auto lg:py-2 lg:px-4 hover:border-b-dark-teal-600 border-b-2 tracking-wide" 
            :class="{ 'bg-dark-teal-600 text-light-pink-100': isActive('collection'), 'bg-white text-dark-teal-600': !isActive('collection') }"
            :to="localePath('collection')"
          >
            {{ t('navigation.collection') }}
          </NuxtLink>
          <NuxtLink
            class="cursor-pointer flex w-full items-center justify-center border border-transparent text-lg no-underline transition-all duration-200 hover:border-b-dark-teal-600 border-b-2 tracking-wide h-12 lg:h-16 lg:w-auto lg:py-2 lg:px-4"
            :class="{ 'bg-dark-teal-600 text-light-pink-100': isActive('about') }"
            :to="localePath('about')"
          >
            {{ t('navigation.about') }}
          </NuxtLink>
          <NuxtLink
            class="cursor-pointer flex w-full items-center justify-center border border-transparent text-lg no-underline transition-all duration-200 hover:border-b-dark-teal-600 border-b-2 tracking-wide h-12 lg:h-16 lg:w-auto lg:py-2 lg:px-4"
            :class="{ 'bg-dark-teal-600 text-light-pink-100': isActive('humans') }"
            :to="localePath('humans')"
          >
            {{ t('navigation.humans') }}
          </NuxtLink>
          <NuxtLink
            class="cursor-pointer flex w-full items-center justify-center border border-transparent text-lg no-underline transition-all duration-200 hover:border-b-dark-teal-600 border-b-2 tracking-wide h-12 lg:h-16 lg:w-auto lg:py-2 lg:px-4"
            :class="{ 'bg-dark-teal-600 text-light-pink-100': isActive('pricing') }"
            :to="localePath('pricing')"
          >
            {{ t('navigation.pricing') }}
          </NuxtLink>
          <NuxtLink
            class="cursor-pointer flex w-full items-center justify-center border border-transparent text-lg no-underline transition-all duration-200 hover:border-b-dark-teal-600 border-b-2 tracking-wide h-12 lg:h-16 lg:w-auto lg:py-2 lg:px-4"
            :class="{ 'bg-dark-teal-600 text-light-pink-100 rounded-r-full lg:pr-8': isActive('features') }"
            :to="localePath('features')"
          >
            {{ t('navigation.features') }}
          </NuxtLink>
        </div>
        <div class="flex flex-col lg:flex-row lg:h-full py-1">
          <span class="lg:py-2">
            <NuxtLink
              class="flex w-full rounded-full rounded-r items-center justify-center h-full px-6 border-white border-t-2 black border-b-2 tracking-wide transition-all duration-200 bg-dark-teal-600 hover:bg-light-pink-200 hover:text-gray-900 text-base text-white uppercase font-medium no-underline tracking-wider"
              :to="localePath('join')"
            >
              {{ t('header.applyCta') }}
            </NuxtLink>
          </span>
          <!-- <a class="flex w-full rounded-full rounded-l items-center justify-center h-full px-6 border-white border-2 bg-light-brown-100 hover:bg-light-pink-200 text-lg text-gray-900 no-underline" href="/users/sign_up">Sell</a> -->
        </div>
      </div>
      <!-- Mobile: Hamburger -->
      <div class="flex items-center lg:hidden">
        <button class="relative flex h-8 w-8 flex-col items-center justify-center focus:outline-none" @click="menuOpen = !menuOpen">
          <div class="mb-1 h-0.5 w-8 origin-center bg-black transition-transform duration-200" :class="{ 'translate-y-[5px] -rotate-45': menuOpen }"></div>
          <div class="mt-1 h-0.5 w-8 origin-center bg-black transition-transform duration-200" :class="{ '-translate-y-[5px] rotate-45': menuOpen }"></div>
        </button>
      </div>
      <!-- Mobile: Slide-in Drawer -->
      <transition name="fade">
        <div v-if="menuOpen" class="fixed inset-0 bg-black/40" @click="menuOpen = false"></div>
      </transition>
      <transition name="slide">
        <div v-if="menuOpen" class="fixed right-0 w-64 h-full bg-white border-l border-gray-200 z-50 flex flex-col p-6 gap-4 shadow-xl lg:hidden" :style="{ top: 'var(--demo-alert-height, 0px)' }">
          <LanguageSwitcher variant="mobile" @locale-selected="menuOpen = false" />
          <button @click="menuOpen = false" class="self-end mb-4" :aria-label="t('header.mobile.close')">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
          <nav class="flex flex-col gap-2">
            <NuxtLink class="p-2 text-lg no-underline hover:text-coral" :to="localePath('humans')" @click="menuOpen = false">{{ t('navigation.humans') }}</NuxtLink>
            <NuxtLink class="p-2 text-lg no-underline hover:text-coral" :to="localePath('pricing')" @click="menuOpen = false">{{ t('navigation.pricing') }}</NuxtLink>
            <NuxtLink class="p-2 text-lg no-underline hover:text-coral" :to="localePath('features')" @click="menuOpen = false">{{ t('navigation.features') }}</NuxtLink>
            <NuxtLink class="p-2 text-lg no-underline hover:text-coral" :to="localePath('about')" @click="menuOpen = false">{{ t('navigation.about') }}</NuxtLink>
          </nav>
          <div class="flex flex-col gap-2 mt-4">
            <NuxtLink
              :to="localePath('collection')"
              class="flex items-center justify-center h-12 px-6 border border-gray-200 rounded-full bg-white text-2xl text-dark-teal-600 no-underline transition-colors duration-200 hover:bg-coral hover:text-dark-teal-600 duration-200 hover:bg-light-pink-200 hover:border-dark-teal-600 font-serif lowercase"
              @click="menuOpen = false"
            >
              {{ t('navigation.collection') }}
            </NuxtLink>
            <NuxtLink
              class="flex items-center justify-center h-12 px-6 border border-gray-200 rounded-full bg-dark-teal-600 text-lg text-white no-underline transition-colors duration-200 hover:text-light-pink-200 duration-200 hover:bg-dark-teal-700"
              :to="localePath('join')"
              @click="menuOpen = false"
            >
              {{ t('header.applyCta') }}
            </NuxtLink>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, computed, nextTick } from 'vue'
import { useRoute, useI18n, useLocalePath } from '#imports'
import CoolStuff from './CoolStuff.vue'
import { useContentStudio } from '~/composables/useContentStudio'
import { useGlobalTheme } from '~/composables/useGlobalTheme'

const menuOpen = ref(false)
const route = useRoute()
const { t, locale } = useI18n()
const localePath = useLocalePath()

// Get theme from Content Studio
const { contentData, loadContentData } = useContentStudio()

// Load Content Studio data immediately (before computed properties are evaluated)
loadContentData()

// Get global theme
const { globalTheme, toggleGlobalTheme, setSampleProductPage, getEffectiveTheme, getSampleProductPageBackgroundColor, isSampleProductPage } = useGlobalTheme()

// Check if user has manually overridden system preference
const isManualOverride = computed(() => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem('global-theme') !== null
  }
  return false
})

const isMounted = ref(false)
const localeRenderKey = computed(() => locale.value)

const themeToggleTitle = computed(() => {
  if (!isMounted.value) {
    return t('common.theme.switch')
  }
  const nextModeKey = globalTheme.value === 'day' ? 'night' : 'day'
  const nextMode = t(`common.theme.mode.${nextModeKey}`)
  const overrideState = t(`common.theme.state.${isManualOverride.value ? 'manual' : 'system'}`)
  return t('common.theme.switchTo', { mode: nextMode, state: overrideState })
})

// Get effective background color based on theme
const effectiveBackgroundColor = computed(() => {
  const effectiveTheme = getEffectiveTheme()
  
  // If on sample product page, use Content Studio background
  if (effectiveTheme === 'content-studio') {
    // Use saved Content Studio background color if available, otherwise use current contentData
    return getSampleProductPageBackgroundColor() || contentData.backgroundColor || '#ffffff'
  }
  
  // Otherwise use the effective theme (system or global)
  if (effectiveTheme === 'night') {
    return '#000000'
  }
  
  return '#ffffff'
})

// Load content data on mount
onMounted(() => {
  // Content data loaded
  isMounted.value = true
})

// Watch for route changes to set sample product page state
watch(() => route.name, (newName) => {
  const normalizedName = typeof newName === 'string' ? newName : newName?.toString() ?? ''
  const isSample = normalizedName.startsWith('sample-product-page')
  setSampleProductPage(isSample)
}, { immediate: true })

// Synchronize Global Theme with Content Studio theme
watch(globalTheme, (newGlobalTheme, oldGlobalTheme) => {
  if (newGlobalTheme && contentData.theme !== newGlobalTheme) {
    // Use nextTick to ensure the update happens after the current tick
    nextTick(() => {
      // Update Content Studio theme to match global theme
      contentData.theme = newGlobalTheme
      // Also update background color to match the theme
      contentData.backgroundColor = newGlobalTheme === 'night' ? '#000000' : '#ffffff'
    })
  }
}, { immediate: true })

const isActive = (name: string) => {
  return route.path === localePath(name)
}

</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.slide-enter-active, .slide-leave-active {
  transition: transform 0.25s cubic-bezier(.4,0,.2,1), opacity 0.2s;
}
.slide-enter-from, .slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style> 